import { PhotoSection, Section } from 'types/images';
import CpeClient from 'shared/clients/CPE';

export enum CpeImageCategory {
  DRIVERS_LICENSE = 'drivers_license',
  VEHICLE_LICENSE = 'car_registration',
  ODOMETER = 'odometer',
  MARBETE = 'marbete',
  VIN = 'vin_number',
  TABLILLA = 'license_plate',
  VEH_PHOTOS = 'vehicle',
  VEH_DAMAGE_PHOTOS = 'vehicle_damage',
  VEH_HOOD_PHOTO = 'vehicle_hood',
  VEH_TRUNK_PHOTO = 'vehicle_trunk',
  VEH_INTERIOR_PHOTOS = 'vehicle_interior',
  ADDITIONAL_DOCS = 'additional_documents',
}

const sicSectionToCpeImageCategory = {
  // Insured photo sections.
  [PhotoSection.INSURED_VEH_DAMAGE_PHOTOS]: CpeImageCategory.VEH_DAMAGE_PHOTOS,
  [PhotoSection.INSURED_VEH_HOOD_PHOTO]: CpeImageCategory.VEH_HOOD_PHOTO,
  [PhotoSection.INSURED_VEH_TRUNK_PHOTO]: CpeImageCategory.VEH_TRUNK_PHOTO,
  [PhotoSection.INSURED_VEH_INTERIOR_PHOTOS]:
    CpeImageCategory.VEH_INTERIOR_PHOTOS,
  [PhotoSection.INSURED_ADDITIONAL_DOCS]: CpeImageCategory.ADDITIONAL_DOCS,

  // Injured photo sections
  [PhotoSection.INJURED_VEH_PHOTOS]: CpeImageCategory.VEH_PHOTOS,
  [PhotoSection.INJURED_VEH_DAMAGE_PHOTOS]: CpeImageCategory.VEH_DAMAGE_PHOTOS,
  [PhotoSection.INJURED_VEH_HOOD_PHOTO]: CpeImageCategory.VEH_HOOD_PHOTO,
  [PhotoSection.INJURED_VEH_TRUNK_PHOTO]: CpeImageCategory.VEH_TRUNK_PHOTO,
  [PhotoSection.INJURED_VEH_INTERIOR_PHOTOS]:
    CpeImageCategory.VEH_INTERIOR_PHOTOS,
  [PhotoSection.INJURED_ADDITIONAL_DOCS]: CpeImageCategory.ADDITIONAL_DOCS,
};

export const cpeCategoryToSicSectionMap = {
  // Insured photo sections
  ['insured_' + CpeImageCategory.DRIVERS_LICENSE]: PhotoSection.INSURED_LICENSE,
  ['insured_' +
  CpeImageCategory.VEHICLE_LICENSE]: PhotoSection.INSURED_VEHICLE_LICENSE,
  ['insured_' + CpeImageCategory.ODOMETER]: PhotoSection.INSURED_ODOMETER,
  ['insured_' + CpeImageCategory.MARBETE]: PhotoSection.INSURED_MARBETE,
  ['insured_' + CpeImageCategory.VIN]: PhotoSection.INSURED_VIN,
  ['insured_' + CpeImageCategory.TABLILLA]: PhotoSection.INSURED_TABLILLA,
  ['insured_' + CpeImageCategory.VEH_PHOTOS]: PhotoSection.INSURED_VEH_PHOTOS,
  ['insured_' +
  CpeImageCategory.VEH_DAMAGE_PHOTOS]: PhotoSection.INSURED_VEH_DAMAGE_PHOTOS,
  ['insured_' +
  CpeImageCategory.VEH_HOOD_PHOTO]: PhotoSection.INSURED_VEH_HOOD_PHOTO,
  ['insured_' +
  CpeImageCategory.VEH_TRUNK_PHOTO]: PhotoSection.INSURED_VEH_TRUNK_PHOTO,
  ['insured_' +
  CpeImageCategory.VEH_INTERIOR_PHOTOS]: PhotoSection.INSURED_VEH_INTERIOR_PHOTOS,
  ['insured_' +
  CpeImageCategory.ADDITIONAL_DOCS]: PhotoSection.INSURED_ADDITIONAL_DOCS,

  // Injured photo sections
  ['injured_' + CpeImageCategory.DRIVERS_LICENSE]: PhotoSection.INJURED_LICENSE,
  ['injured_' +
  CpeImageCategory.VEHICLE_LICENSE]: PhotoSection.INJURED_VEHICLE_LICENSE,
  ['injured_' + CpeImageCategory.ODOMETER]: PhotoSection.INJURED_ODOMETER,
  ['injured_' + CpeImageCategory.MARBETE]: PhotoSection.INJURED_MARBETE,
  ['injured_' + CpeImageCategory.VIN]: PhotoSection.INJURED_VIN,
  ['injured_' + CpeImageCategory.TABLILLA]: PhotoSection.INJURED_TABLILLA,
  ['injured_' + CpeImageCategory.VEH_PHOTOS]: PhotoSection.INJURED_VEH_PHOTOS,
  ['injured_' +
  CpeImageCategory.VEH_DAMAGE_PHOTOS]: PhotoSection.INJURED_VEH_DAMAGE_PHOTOS,
  ['injured_' +
  CpeImageCategory.VEH_HOOD_PHOTO]: PhotoSection.INJURED_VEH_HOOD_PHOTO,
  ['injured_' +
  CpeImageCategory.VEH_TRUNK_PHOTO]: PhotoSection.INJURED_VEH_TRUNK_PHOTO,
  ['injured_' +
  CpeImageCategory.VEH_INTERIOR_PHOTOS]: PhotoSection.INJURED_VEH_INTERIOR_PHOTOS,
  ['injured_' +
  CpeImageCategory.ADDITIONAL_DOCS]: PhotoSection.INJURED_ADDITIONAL_DOCS,
};

export async function postInsuredCpePhoto(
  claimId: string,
  section: Section,
  file: File,
): Promise<void> {
  const cpeSection = sicSectionToCpeImageCategory[section];

  if (!cpeSection) {
    console.warn(`No CPE mapping found for section ${section}`);

    return;
  }

  try {
    await new CpeClient().sendImageValidation(
      [file],
      claimId,
      cpeSection as string,
      false,
    );
  } catch (error: any) {
    console.error(`Error posting image to CPE for section ${section}:`, error);
  }
}
